import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { palette, spaces } from '../../assets/styles/themes/tokens';
import { externalLinks } from '../../constants';

interface FooterLegalNavigationProps {
  isSmallScreen: boolean;
}

const FooterLegalNavigation = ({ isSmallScreen }: FooterLegalNavigationProps) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        marginTop: spaces.xs,
        marginBottom: isSmallScreen ? 0 : spaces.lg,
        gap: spaces.xs,
      }}
    >
      <Link underline='none' href={externalLinks.dataPolicy}>
        <Typography variant='body1' color={palette.primary.main}>{t('Data Policy')}</Typography>
      </Link>
      <Typography color={palette.text.secondary}>•</Typography>
      <Link underline='none' href={externalLinks.tac}>
        <Typography variant='body1' color={palette.primary.main}>{t('Terms and Conditions')}</Typography>
      </Link>
    </Box>
  );
};

export default FooterLegalNavigation;
